import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
import queryString from 'query-string';
// import { CallInternalActions, MissedCallCampaignManage } from './components';
const CallInternalActions = lazy(() => import(/* webpackChunkName: "CallInternalActions" */ './components'));
// const missedCallCampaignCreateForm = ({ match }) => {
//     return <MissedCallCampaignManage mode="create" missedCallCampaignId={match.params._id} />;
// };
// const missedCallCampaignEditForm = ({ match }) => {
//     return <MissedCallCampaignManage
//         mode="edit"
//         missedCallCampaignEditId={match.params._id}
//         missedCallCampaignId={match.params.MissedCallCampaignId}
//     />;
// };

const routes = () => {
    return (
        <React.Fragment>
            <PrivateRoute
                key="/settings/missed-call-to-campaign"
                exact={true}
                path="/settings/missed-call-to-campaign"
                component={CallInternalActions}
            />
            {/* <PrivateRoute
                key="/settings/call-internal-actions/id/create"
                exact={true}
                path="/settings/integrations/missedCallCampign/:_id/create"
                component={missedCallCampaignCreateForm}
            />
            <PrivateRoute
                key="/settings/integrations/missedCallCampign/edit/id"
                exact={true}
                path="/settings/integrations/missedCallCampign/:missedCallCampaignId/edit/:_id"
                component={missedCallCampaignEditForm}
            /> */}
            {/* <PrivateRoute
        key="/settings/integrations/webHook/editData/id"
        exact={true}
        path="/settings/integrations/webHook/editData/:_id"
        component={webHookEditFormData}
      /> */}
        </React.Fragment>
    );
};

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/CallInternalActions/routes.js